module.exports = __webpack_public_path__ + "static/img/login01.05a541c3.png";